export default __webpack_public_path__ + "static/featureImg4-b8f6a62f3b9a078067473586aab2322b.png";